import { get } from 'lodash';
import { connect } from 'react-redux';

import Homepage from 'components/Homepage';
import { CAMPAIGN_NAMES } from 'constants/personalizations';
import * as actions from 'state/actions';
import { MODAL_TYPES } from 'state/constants';
import PersonalizationsSelector from 'state/selectors/personalizations';
import Rudderstack from 'utils/Rudderstack';

const mapStateToProps = (state, ownProps) => {
  const { homepageData } = ownProps;

  const isModalOpen = get(state, ['app', 'modal']) === MODAL_TYPES.HOMEPAGE_HERO_VIDEO;
  const isConsentConfirmationModalOpen =
    get(state, ['app', 'modal']) === MODAL_TYPES.CONSENT_CONFIRMATION;
  const consentDecision = get(state, ['app', 'modalConsentConfirmationDecision']);

  const miniNavigationPlacementExperimentVariation =
    PersonalizationsSelector.getCampaignVariationData(
      state,
      CAMPAIGN_NAMES.HP_DESKTOP_MINI_NAV_PLACEMENT
    );
  const miniNavigationPosition =
    miniNavigationPlacementExperimentVariation?.payload?.data?.position ??
    homepageData.hero.miniNavigationPosition;
  const miniNavigationPlacementExperimentAnalyticsData = {
    dyDecisionId: miniNavigationPlacementExperimentVariation?.decisionId,
    dyVariationId: miniNavigationPlacementExperimentVariation?.analyticsMetadata?.variationId,
  };
  const isMiniNavigationExperimentLoading = PersonalizationsSelector.getIsExperimentLoading(
    state,
    CAMPAIGN_NAMES.HP_DESKTOP_MINI_NAV_PLACEMENT
  );

  const multiTouchCampaignData = PersonalizationsSelector.getTargetedPageSectionCampaignData(
    state,
    CAMPAIGN_NAMES.MULTI_TOUCH_CAMPAIGN,
    homepageData?.experimentPageSections
  );
  const personalizedPageSections = homepageData?.pageSections?.map(section => {
    const matchedContent = multiTouchCampaignData?.activePageSections?.find(
      activePageSection => activePageSection._contentType === section._contentType
    );

    return matchedContent || section;
  });
  const multiTouchCampaignAnalyticsMetadata = multiTouchCampaignData?.analyticsMetadata
    ?.dyDecisionId
    ? {
        dyDecisionId: multiTouchCampaignData.analyticsMetadata.dyDecisionId,
        dyVariationId: multiTouchCampaignData.analyticsMetadata.dyVariationId,
      }
    : null;

  return {
    homepageData: {
      ...homepageData,
      hero: {
        ...homepageData.hero,
        miniNavigationPosition,
      },
      pageSections: personalizedPageSections,
    },
    isMiniNavigationExperimentLoading,
    isMultiTouchCampaignLoading: multiTouchCampaignData?.isLoading,
    miniNavigationPlacementExperimentAnalyticsData,
    multiTouchCampaignAnalyticsMetadata,
    isModalOpen,
    isConsentConfirmationModalOpen,
    consentDecision,
  };
};

const mapDispatchToProps = dispatch => ({
  openModal: () => dispatch(actions.openHomepageHeroVideoModal()),
  closeModal: () => dispatch(actions.closeModal()),
  trackModuleEvent: ({
    moduleType,
    moduleName,
    modulePosition,
    carouselCategoryName,
    carouselCardPosition,
    carouselCardName,
    imageName,
    linkCTAName,
    linkDestination,
    dyDecisionId,
    dyVariationId,
  }) => {
    Rudderstack.homepageModuleClick({
      moduleType,
      moduleName,
      modulePosition,
      carouselCategoryName,
      carouselCardPosition,
      carouselCardName,
      imageName,
      linkCTAName,
      linkDestination,
    });

    dispatch(
      actions.trackEngagementClick({
        dyDecisionId,
        dyVariationId,
      })
    );
  },
  signUpForNewsletter: params => dispatch(actions.signUpForNewsletter(params)),
  closeConsentConfirmationModal: () => dispatch(actions.closeModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);
